import { useMemo, useCallback } from 'react';
import find from 'lodash/find';
import first from 'lodash/first';

import {
  FetchProductsFilters,
  ChangeProductsFiltersFunc
} from '../../../../../productsTypes';

import { ProductsIndexPageCategoriesNavCategory } from '../../ProductsIndexPageCategoriesNav.types';

import { getChangeProductsFiltersCategoriesData } from '../../../../../utils/getChangeProductsFiltersCategoriesData';

interface UseProductsIndexPageCategoriesNavBodyOptions {
  productCategories: ProductsIndexPageCategoriesNavCategory[];
  productsFilters: FetchProductsFilters;
  changeProductsFilters: ChangeProductsFiltersFunc;
}

function useProductsIndexPageCategoriesNavBody({
  productCategories,
  productsFilters,
  changeProductsFilters
}: UseProductsIndexPageCategoriesNavBodyOptions) {
  const currentParentCategory = useMemo(() => {
    const currentFiltersParentCategoryId = first(
      productsFilters?.productParentCategoryIds
    );

    return (
      find(productCategories, ['id', currentFiltersParentCategoryId]) || null
    );
  }, [productCategories, productsFilters]);

  const currentChildCategory = useMemo(() => {
    const currentFiltersChildCategoryId = first(
      productsFilters?.productCategoryId?.in
    );

    return (
      find(productCategories, ['id', currentFiltersChildCategoryId]) || null
    );
  }, [productCategories, productsFilters]);

  const handleResetCategoriesFilters = useCallback(() => {
    const { changeFilters, resetFilters } =
      getChangeProductsFiltersCategoriesData({
        productCategory: null,
        categories: []
      });

    changeProductsFilters(changeFilters, resetFilters);
  }, [changeProductsFilters]);

  const handleParentCategoryChangeFilters = useCallback(() => {
    const { changeFilters, resetFilters } =
      getChangeProductsFiltersCategoriesData({
        productCategory: currentParentCategory,
        categories: productCategories
      });

    changeProductsFilters(changeFilters, resetFilters);
  }, [changeProductsFilters, currentParentCategory, productCategories]);

  return {
    currentParentCategory,
    currentChildCategory,
    handleResetCategoriesFilters,
    handleParentCategoryChangeFilters
  };
}

export default useProductsIndexPageCategoriesNavBody;
